import { Button, NavigationButton } from "@jutro/ui";
import { useAtom } from "jotai";
import { useState } from "react";
import { chosenMedicalRecordsAtom } from "components/TagFormNew/Sections/atoms";
import { Loader } from "components/new";
import { SelectMedicalDocumentationTable } from "components/new/MedicalDocumentation/FileSelectTable";
import {
  DoctorMSMedicalRecordEntity,
  useDoctorGetDocumentsQuery,
} from "lib/graphql/megaSchema";
import { useGetPatientId } from "lib/hooks/useGetPatientId";
import { useTileSystem } from "lib/tools/createWorkspace/useTileSystem";

type Props = {
  chosenFiles: DoctorMSMedicalRecordEntity[];
};

export const MedicalRecordFileSelectTile = ({ chosenFiles }: Props) => {
  const { removeTile } = useTileSystem();
  const patientId = useGetPatientId();
  const [, setChosenDocuments] = useAtom(chosenMedicalRecordsAtom);
  const [selectedRows, setSelectedRows] =
    useState<DoctorMSMedicalRecordEntity[]>(chosenFiles);

  const { data } = useDoctorGetDocumentsQuery({
    fetchPolicy: "cache-and-network",
    variables: { id: patientId },
    skip: !patientId,
  });

  const cleanUpTile = () => {
    removeTile("medical-record-file-select");
    setSelectedRows([]);
  };

  if (!data?.doctorPatient?.documents) return <Loader />;

  return (
    <div className="flex flex-col gap-4 rounded-lg bg-white p-4">
      <div className="flex items-center justify-between">
        <h4 className="font-heading-4">Dodaj plik z dokumentacji</h4>

        <NavigationButton onClick={cleanUpTile} />
      </div>

      <SelectMedicalDocumentationTable
        data={data.doctorPatient.documents as DoctorMSMedicalRecordEntity[]}
        chosenMedicalRecords={chosenFiles}
        selectedMedicalRecords={selectedRows}
        setSelectedMedicalRecords={setSelectedRows}
      />

      <Button
        text="Zatwierdź"
        onClick={() => {
          setChosenDocuments(selectedRows);
          cleanUpTile();
        }}
      />
    </div>
  );
};
